<template>
  <AppSection
    id="vendor-timesheet-details"
    type="page"
    :title="$getConst.pages.vendor_timesheet_details.vendor_timesheet_details_page_title"
  >
      <VendorTimesheetDetails :timesheet="timesheet" :is-loading="isLoading"/>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import {getVendorTimesheet} from "../../../api/vendorTimesheets.api";
  import VendorTimesheetDetails from "./VendorTimesheetDetails";
  export default {
    name: "index",
    components: {VendorTimesheetDetails, AppSection},
    props: {
      timesheetId: null
    },
    data() {
      return {
        isLoading: false,
        timesheet: null
      }
    },
    methods: {
      getTimesheetDetails() {
        this.isLoading = true;
        getVendorTimesheet(this.timesheetId).then(
          (response) => {
            this.timesheet = response.data;
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.handleApiError(error);
          }
        )
      }
    },
    created() {
      this.getTimesheetDetails();
    }
  }
</script>

<style scoped>

</style>
